import { useTranslation } from "react-i18next";
import PlayersRoster from "@/components/players/PlayersRoster";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function SquadPage() {
  const { t } = useTranslation();
  usePageTitle(`${t("v2.nav.squad")} — ${t("app.name")}`);

  return (
    <PlayersRoster
      headingKey="v2.squad.title"
      descriptionKey="v2.squad.description"
      fetchErrorKey="v2.squad.loadError"
      profileMode
    />
  );
}
